export default __webpack_public_path__ + "static/media/Karthik.d1abcf09.jpg";